require('./fieldRuleBuilder.i18n.json');
require('./fieldRuleBuilder.tpl.html');
require('./fieldRuleBuilderController.js');
require('./fieldRuleBuilderRepository.js');

const FieldRuleBuilderComponent = {
    templateUrl: '/configuration/formEditor/content/rule/fieldRuleBuilder/fieldRuleBuilder.tpl.html',
    controller: 'fieldRuleBuilderController',
    bindings: {
        fieldRule: '<',
        canUserManageFormRules: '<',
        focusOnRuleName: '<'
    }
};

angular.module('ums')
    .component('uiFieldRuleBuilder', FieldRuleBuilderComponent);
